import mediaHome from "./mediaHome.vue";
export default mediaHome;
